import React from "react";
import { MenuItem, Select } from "@material-ui/core";
import styles from "styles/admin-search.module.scss";

type Props = {
  state: any; // NOTE: Search.jsで定義されているstateに型情報がないため
  action: (e: any) => void;
  options: ReadonlyArray<{label: string, value: any}>;
};

/**
 * 検索条件用のセレクトボックスコンポーネント
 * @param  props stateとその更新関数、stateの取り得る値の組み合わせ
 */
const StatusSelectField: React.FC<Props> = (props) => {
  const { state, action, options } = props;
  const handleChange = (e: any) => action(e.target.value);

  return (
    <Select
      className={styles.searchConditionSelectBox}
      value={state ?? ""}
      onChange={handleChange}
    >
      <MenuItem key={"0"} value={undefined}>
        &nbsp;
      </MenuItem>
      {options.map(({ label, value }) => {
        return (
          <MenuItem key={label} value={value}>
            {label}
          </MenuItem>
        );
      })}
      ;
    </Select>
  );
};

export { StatusSelectField };
